import { NodeInterface } from '../../swivl-lib'
import { MatrixInterface } from './Matrix.Interfaces'

export enum InheritanceStatus {
  IS_PARENT = 'parent',
  IS_CHILD = 'child',
  NONE = 'none'
}

export const UNASSIGNED_TO_JOURNEY_SLUG = 'unassigned'

export enum QuestType {
  NORMAL = 'normal',
  MATRIX = 'matrix',
  ROUTER = 'router',
  DEFAULT_UNHANDLED = 'default unhandled',
  VOICE_ROUTER = 'voice router',
  GMB_ROUTER = 'GMB router'
}

export type QuestInterfaceInternal = {
  // This is used for our old codebase, pre slug
  id: string
  name: string
}

export type Slug = string
export type NodeMap = { [nodeId: string]: NodeInterface }
export interface BaseQuestInterface {
  createdAt: Date
  updatedAt: Date
  botId: string

  slug: string
  name: string
  inheritance: InheritanceStatus
  type: QuestType
  journeySlug?: Slug
  brainSlug?: string
  order?: number
  data: any
  isParseObject?: any // THIS IS TEMPORARY UNTIL WE REMOVE THE PARSE QUESTS
}
export interface MatrixQuestInterface extends BaseQuestInterface {
  type: QuestType.MATRIX
  data: MatrixInterface
}

export interface NormalQuestInterface extends BaseQuestInterface {
  type:
    | QuestType.NORMAL
    | QuestType.ROUTER
    | QuestType.DEFAULT_UNHANDLED
    | QuestType.VOICE_ROUTER
    | QuestType.GMB_ROUTER
  data: NodeMap
}
export type QuestInterface = MatrixQuestInterface | NormalQuestInterface

export enum JourneyType {
  NORMAL = 'normal',
  QUICK_REPLIES = 'quick replies',
  VOICE = 'voice'
}

export interface JourneyInterface {
  createdAt: Date
  updatedAt: Date
  botId: string

  inheritance: InheritanceStatus.NONE | InheritanceStatus.IS_PARENT
  name: string
  slug: Slug
  type: JourneyType
  brainSlug?: string
  order?: number
}
